/** @graphql cc **/
import gql from 'graphql-tag';

export const UserPrivilegeQuery = gql`
	query UserPrivilegeQuery {
		user: confluence_atlassianUser(current: true) {
			id
			confluence {
				operations {
					operation
					targetType
				}
			}
		}
		isSiteAdmin
		hasUserAccessAdminRole
	}
`;
